import { Link } from "react-router-dom";

interface SectionHeaderProps {
  title: string;
  viewAllHref?: string;
  viewAllLabel?: string;
}

const SectionHeader = ({ title, viewAllHref, viewAllLabel = "See All" }: SectionHeaderProps) => (
  <header className="mb-7 flex flex-col items-center gap-3 text-center md:mb-10 md:flex-row md:items-end md:justify-between md:gap-5 md:text-left">
    <h2 className="flex items-center gap-4 font-heading text-3xl font-medium leading-none text-foreground md:text-5xl">
      <span className="hidden h-px w-10 bg-primary sm:inline-block" />
      <span>{title}</span>
    </h2>
    {viewAllHref && (
      <Link
        to={viewAllHref}
        className="hidden whitespace-nowrap border-b border-primary pb-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-foreground transition-colors hover:text-primary md:inline-block md:text-xs"
      >
        {viewAllLabel}
      </Link>
    )}
  </header>
);

export default SectionHeader;
